module.exports = __webpack_public_path__ + "img/img6.6aba05a1.svg";